import React, { useEffect, useState } from "react";
import "./Toggle.css";
import { config } from "../utils/config";
import { doRequest } from "../utils/helper";
import Sidebar from "./Sidebar";
import PlansList from "./PlansList";

export default function PlansOld() {
  const initialUserPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS);

  const userIsLoggedIn = localStorage.getItem(config.USER_LOGIN_DETAILS)
    ? JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS))
    : null;
  const [yearly, setYearly] = useState(false);
  const [plansList, setPlansList] = useState([]);

  const getPlansList = async () => {
    try {
      let res = await doRequest({}, "GET", `plan/list`);
      if (+res?.resultFlag === 1) {
        setPlansList(res?.response?.plans);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getPlansList();
  }, []);

  return (
    <>
      <div
        id="main-container"
        className="container-fluid main"
        style={{ overflowY: "scroll" }}
      >
        {userIsLoggedIn &&
          window.location.pathname != "/" &&
          initialUserPlanDetails && <div class="left-main-menu"><Sidebar /></div>}
        <div style={{ width: "100%" }} className="container">
          <section className="sub_sec sub_sec_cms" id="sub_sec">
            <img
              src="/assets/images/ringcms.svg"
              className="ring_img_cms"
              alt=""
            />
            <div className="container container_sub">
              <div className="row">
                <div className="col-sm-12">
                  <div>
                    <h2 className="plan_heading">
                      Teedex Flexible Pricing Plans
                    </h2>
                    <p className="plan_text">
                      Whether you’re a small team or a large organization, we
                      have the perfect plan for you to streamline your custom
                      jersey designs. Accelerate your jersey creation process
                      with Teedex’s adaptable pricing options!
                    </p>

                    <div className="toggleBlock">
                      <div className="toggleBlockList">
                        <div
                          className={`toggleBlockItem ${
                            yearly === false ? "active" : ""
                          }`}
                          onClick={() => setYearly(false)}
                        >
                          Monthly
                        </div>
                        <div
                          className={`toggleBlockItem ${
                            yearly === true ? "active" : ""
                          }`}
                          onClick={() => setYearly(true)}
                        >
                          Yearly
                        </div>
                        <div
                          className={`toggleBlockItem-background ${
                            yearly === false ? "monthly" : "yearly"
                          }`}
                        ></div>
                      </div>
                      <div className="toggleBlockInfo">2 Months Free</div>
                    </div>
                  </div>
                </div>
              </div>

              <PlansList yearly={yearly} plansList={plansList} />

              <div className="row">
                <div className="col-sm-12">
                  <div className="var_plan">
                    <p>
                      Unlock the full potential of your tee shirt designs with
                      our flexible subscription options tailored to your unique
                      needs. Whether you’re a sporadic designer or a high-volume
                      creator.
                    </p>
                    <h6>Teedex has a plan for you.</h6>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
